import React, { useEffect, useState } from 'react'
import { MasonryLayout } from './MasonryLayout';
import { client } from '../client';
import { userCreatedPostsQuery, userQuery, userSavedPostsQuery } from '../utils/userData';
import { useNavigate, useParams } from 'react-router-dom';
import HashLoader from "react-spinners/HashLoader";



const activeBtnStyles = 'bg-red-600 text-white font-bold p-2 rounded-full w-20 outline-none shadow-2xl hover:scale-90 transition duration-500';
const notActiveBtnStyles = 'bg-primary mr-4 text-black font-bold p-2 rounded-full w-20 outline-none shadow-2xl hover:bg-red-300 hover:scale-90 transition duration-500';


export const UserProfile = () => {

  const [user, setUser] = useState();
  const [posts, setPosts] = useState();
  const [text, setText] = useState('Created');
  const [activeBtn, setActiveBtn] = useState('created');
  const { userId } = useParams();

  const navigate = useNavigate();

  const User = localStorage.getItem('user') !== 'undefined' ? JSON.parse(localStorage.getItem('user')) : localStorage.clear();

  useEffect(() => {
    const query = userQuery(userId);
    client.fetch(query).then((data) => {
      setUser(data[0]);
    });
  }, [userId]);

  useEffect(() => {
    if (text === 'Created') {
      const createdPostsQuery = userCreatedPostsQuery(userId);

      client.fetch(createdPostsQuery).then((data) => {
        setPosts(data);
      });
    } else {

      const savedPostsQuery = userSavedPostsQuery(userId);

      client.fetch(savedPostsQuery).then((data) => {
        setPosts(data);
      });
    }
  }, [text, userId]);


  if (!user) return <div className='flex justify-center items-center h-screen'><HashLoader color="#dc2626" /></div>;



  const logout = () => {
    localStorage.clear();

    navigate('/login');
  };


  return (
    <div className="relative pb-2 h-full justify-center items-center">
      <div className="flex flex-col pb-5">
        <div className="relative flex flex-col mb-7">
          <div className="flex flex-col justify-center items-center">
            <img
              className=" w-full h-200 2xl:h-510 shadow-lg object-cover"
              src="https://source.unsplash.com/1600x900/?nature,technology"
              alt="user-pic"
            />
            <img
              className="rounded-full w-20 h-20 -mt-10 shadow-xl object-cover"
              src={user.image}
              alt="user-pic"
            />
          </div>
          <h1 className="font-bold text-3xl text-center mt-3">
            {user.userName}
          </h1>

          {
            userId === User?.sub
            &&
            <div className='w-full flex justify-center items-center text-xl p-5 text-center text-white'>
              <button className='flex justify-center items-center p-1 rounded-full bg-red-600 w-32 shadow-2xl hover:scale-90 transition duration-500' onClick={()=>logout()}>Logout</button>
            </div>
          }
        </div>
        <div className="text-center mb-7">
          <button
            type="button"
            onClick={(e) => {
              setText(e.target.textContent);
              setActiveBtn('created');
            }}
            className={`${activeBtn === 'created' ? activeBtnStyles : notActiveBtnStyles}`}
          >
            Created
          </button>
          <button
            type="button"
            onClick={(e) => {
              setText(e.target.textContent);
              setActiveBtn('liked');
            }}
            className={`${activeBtn === 'liked' ? activeBtnStyles : notActiveBtnStyles}`}
          >
            Liked
          </button>
        </div>

        <div className="px-2">
          <MasonryLayout posts={posts} />
        </div>

        {posts?.length === 0 && (
        <div className="flex justify-center font-bold items-center w-full text-1xl mt-2">
          No Posts found.
        </div>
        )}
      </div>

    </div>

  )
}
